








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Return extends Vue {
  @Prop({ type: String, default: '' })
  readonly name!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/components/header/Header.vue